module.exports = __webpack_public_path__ + "static/p08_back-bade7aa56ec0eb6953a2c8508ff0d786.jpg";